<template lang="pug">
  SmallView(
    v-if='track'
    type='track'
    :cover='cover'
    :title='track.name || $l10n("NO_NAME")'
    :link='`/tracks/${track.id}`'
    :duration='track.duration'
    :artists='track.artists'
  )
</template>

<script>
import SmallView from "@/components/SmallView/SmallView";

export default {
  name: "TrackSmallView",
  props: ["track"],
  computed: {
    cover() {
      return this.track.cover ? this.track.cover.small : "";
    }
  },
  components: { SmallView }
};
</script>
